module.exports = __webpack_public_path__ + "static/fivestone-d075867aa85664ffbbbd6f274068f4ff.png";